import FormElementMixin from '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin';
import codemirror from '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/lib/codemirror.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/mode/javascript/javascript.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/mode/htmlmixed/htmlmixed.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/mode/css/css.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/addon/edit/closebrackets.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/addon/edit/matchbrackets.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/addon/edit/matchtags.js';
import '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/assets/vendor/codemirror/addon/edit/closetag.js';

Vue.asyncComponent('ak-wysiwyg', {
    mixins: [FormElementMixin],
    props: {
        configOptions: {
            type: Object | Array,
            required: true
        },
    },
    watch: {
        value(newValue, oldValue) {
            if (!this.$deepEqual(newValue, oldValue)) {
                this.$refs.redactor.redactorx.app.editor.setContent({ html: this.currentValue });
            }
        },
        activeLocale() {
            this.$refs.redactor.redactorx.destroy();
        }
    },
    computed: {
        activeLocale() {
            return this.$localeHandler.getActiveLocale();
        },
        currentConfigOptions() {
            return {
                ...this.configOptions,
                image: {
                    ...this.configOptions.image,
                    upload: this.$getSetting('paths.baseAppKit') + this.configOptions.image.upload
                },
                editor: {
                    lang: 'nl',
                    ...this.configOptions.editor,
                },
                clean: true,
                codemirrorSrc: codemirror,
                codemirror: {
                    lineWrapping: true,
                    lineNumbers: true,
                    theme: this.darkModeActive ? 'material-ocean' : 'default',
                    mode: 'text/html',
                    readOnly: this.readOnly,
                    matchBrackets: true,
                    autoCloseBrackets: true,
                    autoCloseTags: true,
                    matchTags: {
                        bothTags: true
                    }
                },
                placeholder: this.placeholder,
                subscribe: {
                    'editor.focus': this.focus,
                    'editor.blur': (event) => {
                        const editor = this.$refs.redactor.redactorx.editor;

                        let content = editor.getContent();

                        if (content === '<p><br></p>') {
                            editor.setEmpty();
                        }

                        this.blur(event);
                    },
                    'app.start': () => {
                        this.$el.querySelectorAll('.rx-toolbar').forEach(btn => {
                            btn.setAttribute('tabindex', '-1');
                        });
                    },
                    'editor.keydown': (event) => {
                        this.$emit('keydown', event.params.e);
                    },
                    'source.change': (event) => {
                        this.currentValue = event.params.e.getValue();
                    },
                    'source.open': () => {
                        this.$nextTick(() => {
                            const redactorRef = this.$refs.redactor;
                            const redactor = redactorRef && redactorRef.redactorx ? redactorRef.redactorx : null;
                            const editorContainer = redactor && redactor.app && redactor.app.container
                                ? redactor.app.container.get('editor')
                                : null;
                            const sourceEditor = redactor && redactor.app && redactor.app.container
                                ? redactor.app.container.get('source')
                                : null;
                            const codemirrorInstance = redactor && redactor.app && redactor.app.codemirror
                                ? redactor.app.codemirror.cm
                                : null;

                            if (!editorContainer || !sourceEditor || !codemirrorInstance) {
                                return;
                            }

                            const baseHeight = editorContainer.height();
                            const sourceHeight = `${baseHeight * 4}px`;

                            sourceEditor.height(sourceHeight);
                            codemirrorInstance.setSize(null, sourceHeight);
                            codemirrorInstance.refresh();
                        });
                    },
                    ...this.$currentListeners
                }
            }
        },
        darkModeActive() {
            if (!this.$darkModeHandler) {
                return false;
            }

            return this.$darkModeHandler.darkMode;
        }
    }
}, 'form/controls/ak-wysiwyg.html');
